"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustmentReducer = void 0;
const adjustment_component_1 = __importDefault(require("./adjustment.component"));
const adjustment_reducer_1 = __importDefault(require("./adjustment.reducer"));
exports.adjustmentReducer = adjustment_reducer_1.default;
exports.default = adjustment_component_1.default;
